import { makeStyles } from '@material-ui/core';

const rem = (px: number) => `${px / 10}rem`;

const bannerPalette = {
    background: '#FFF8ED',
    backgroundPressed: '#FEF0C7',
    border: '#E69E42',
    icon: '#E69E42',
    title: '#1E2A3A',
    subtitle: '#6B7280',
};

export default makeStyles(() => ({
    wrapper: {
        display: 'flex',
        alignItems: 'center',
        gap: rem(12),
        margin: `${rem(8)} ${rem(16)} 0`,
        padding: rem(12),
        borderRadius: rem(12),
        backgroundColor: bannerPalette.background,
        border: `1px solid ${bannerPalette.border}`,
        cursor: 'pointer',
        '&:active': {
            backgroundColor: bannerPalette.backgroundPressed,
        },
    },
    leadingIcon: {
        width: rem(24),
        height: rem(24),
        flexShrink: 0,
        color: bannerPalette.icon,
    },
    textBlock: {
        display: 'flex',
        flexDirection: 'column',
        gap: rem(2),
        flex: 1,
        minWidth: 0,
    },
    title: {
        color: bannerPalette.title,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    subtitle: {
        color: bannerPalette.subtitle,
        display: '-webkit-box',
        '-webkit-line-clamp': 2,
        '-webkit-box-orient': 'vertical',
        overflow: 'hidden',
    },
    chevron: {
        flexShrink: 0,
        color: bannerPalette.icon,
        fontSize: rem(20),
    },
}));
